import { render } from "./WidgetLista.vue?vue&type=template&id=47c4351c&scoped=true&ts=true"
import script from "./WidgetLista.vue?vue&type=script&lang=ts"
export * from "./WidgetLista.vue?vue&type=script&lang=ts"

import "./WidgetLista.vue?vue&type=style&index=0&id=47c4351c&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c4351c"]])

export default __exports__